
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import '@/utils/filter'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import '@css/common.scss'
import '@css/plugins.scss'
import 'lib-flexible/flexible'  // 适配移动端


import { Input, Select, Option, Menu, Submenu, MenuItem, Loading, Message, MessageBox, Dialog,  Carousel, CarouselItem, Table, TableColumn, } from 'element-ui'
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Dialog)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading.directive)
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm


// 引入动画
import animated from 'animate.css'
Vue.use(animated)

// 引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, { ak: "3MFionmUG4w9Ty4DoQKhWL8SyWpHV0WQ" })

// 解决SEO的问题
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)


import { get, post } from './utils/request'
Vue.prototype.$get = get
Vue.prototype.$post = post

Vue.config.productionTip = false


//全局混入
Vue.mixin({
    data() {
        return {
            screen_height: 0,
        }
    },
    beforeMount() {
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.screen_height= (h/2 - 100)
    },
    methods: {
        /**
         * @param msg - 传入文本
         * @param type - 弹框类型，默认警告
         * @param time - 显示时间，默认1秒
         * @param offset - 弹框位置，默认屏幕中间
         */
        Message(msg, type, time, offset) {
            let h = this.screen_height
            this.$message({
                message: msg,
                type: type? type : 'warning',
                duration: time ? time : 1000,
                offset: offset ? offset : h,
            })
        },
    },
})



// router.beforeEach((to, from, next) => {
//     console.log('beforeEach',to,from)
//     next()
// });


new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    mounted () {
        document.dispatchEvent(new Event('render-event'))
    }
})





// WEBPACK FOOTER //
// ./src/main.js